import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Mandant } from '../../../../projects/kiene-core/src/lib/components/mandanten/classes/mandant';
import { SelectMandantDialogInput } from './select-mandant-dialog';

@Component({
    selector: 'kiene-select-mandant-dialog',
    templateUrl: './select-mandant-dialog.component.html',
    styleUrls: ['./select-mandant-dialog.component.scss'],
    host: { '(window:keydown)': 'checkForNumberKey($event)' },
})
export class SelectMandantDialogComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<SelectMandantDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public input: SelectMandantDialogInput,
    ) {}

    ngOnInit() {}

    checkForNumberKey(event) {
        const numberOfAvailableMandanten = this.input?.mandanten?.length;

        const numberPressed = String.fromCharCode(event.which);

        for (let i = 0; i < numberOfAvailableMandanten; i++) {
            if (i + 1 === parseInt(numberPressed, 10)) {
                this.setMandant(this.input?.mandanten[i]);
            }
        }
    }

    setMandant(m: Mandant) {
        this.dialogRef.close(m);
    }
}
